module.exports = __webpack_public_path__ + "img/Bumper-image.f1d5e6f0.jpg";